var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"PreviousTransactions"}},[_c('div',{staticClass:"panel"},[_c('prevTransactions',{attrs:{"results":_vm.results}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }